//GET MANUAL URL
export const MANUAL_URL = "MANUAL_URL"
export const MANUAL_BY_CLIENT = "MANUAL_BY_CLIENT"
export const MANUAL_BY_SITEID = "MANUAL_BY_SITEID"
export const MANUAL_DATA_SUCCESS = "MANUAL_DATA_SUCCESS"
export const ALL_MANUAL_DATA_SUCCESS = "ALL_MANUAL_DATA_SUCCESS"
export const MANUAL_DATA_ERROR = "MANUAL_DATA_ERROR"
export const MANUAL_DATA = "MANUAL_DATA"

//GET ALL CATEGORY
export const ALL_CATEGORY_DATA_SUCCESS = "ALL_CATEGORY_DATA_SUCCESS"
export const CATEGORY_LIST_SUCCESS = "CATEGORY_LIST_SUCCESS"
export const CATEGORY_LIST_ERROR = "CATEGORY_LIST_ERROR"

//GET CHANGETYPE
export const CHANGETYPE_LIST_SUCCESS = "CHANGETYPE_LIST_SUCCESS"
export const ALL_CHANGETYPE_DATA = "ALL_CHANGETYPE_DATA"
export const CHANGETYPE_LIST_ERROR = "ALL_CHANGETYPE_ERROR"
//ADD ,update,delete manual
export const ADD_MANUAL = "ADD_MANUAL"
export const ADD_MANUAL_SUCCESS = "ADD_MANUAL_SUCCESS"
export const ADD_MANUAL_ERROR = "ADD_MANUAL_ERROR"
export const UPDATE_NEW_MANUAL = "UPDATE_NEW_MANUAL"
export const UPDATE_NEW_MANUAL_SUCCESS = "UPDATE_NEW_MANUAL_SUCCESS"
export const UPDATE_NEW_MANUAL_ERROR = "UPDATE_NEW_MANUAL_ERROR"
export const DELETE_MANUAL_BYID = "DELETE_MANUAL_BYID"
export const DELETE_MANUAL_SUCCESS = "DELETE_MANUAL_SUCCESS"
export const DELETE_MANUAL_ERROR = "DELETE_MANUAL_ERROR"

export const MANUAL_CLIENT_DATA_SUCCESS = "MANUAL_CLIENT_DATA_SUCCESS"

//ADD ,update,delete drawing
export const ADD_DRAWING = "ADD_DRAWING"
export const ADD_DRAWING_SUCCESS = "ADD_DRAWING_SUCCESS"
export const ADD_DRAWING_ERROR = "ADD_DRAWING_ERROR"
export const UPDATE_NEW_DRAWING = "UPDATE_NEW_DRAWING"
export const UPDATE_NEW_DRAWING_SUCCESS = "UPDATE_NEW_DRAWING_SUCCESS"
export const UPDATE_NEW_DRAWING_ERROR = "UPDATE_NEW_DRAWING_ERROR"
export const DELETE_DRAWING_BYID = "DELETE_DRAWING_BYID"
export const DELETE_DRAWING_SUCCESS = "DELETE_DRAWING_SUCCESS"
export const DELETE_DRAWING_ERROR = "DELETE_DRAWING_ERROR"

//Get CategoryDrawing by siteid
export const CATEGORY_DRAWING_DATA = "CATEGORY_DRAWING_DATA"
export const CATEGORY_DRAWING_DATA_SUCCESS = "CATEGORY_DRAWING_DATA_SUCCESS"
export const CATEGORY_DRAWING_DATA_ERROR = "CATEGORY_DRAWING_DATA_ERROR"
